// Bilingual translations for Inversiones Tair SpA
export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Quiénes Somos',
      whatWeDo: 'Qué Hacemos',
      contact: 'Contacto',
    },
    common: {
      learnMore: 'Conocer más',
      back: 'Volver',
      readMore: 'Leer más',
      visitSite: 'Visitar sitio',
      ourPartners: 'Nuestros socios',
      keyFeatures: 'Características clave',
      products: 'Productos',
    },
    home: {
      eyebrow: 'Holding de inversiones · Chile · desde 2012',
      heroTitle1: 'Va a traer',
      heroTitle2: 'luz.',
      heroSubtitle: 'Inversiones Tair SpA es un holding chileno que ilumina el camino entre la visión y la inversión: desarrollo inmobiliario, bodegaje industrial y software con propósito.',
      ctaPrimary: 'Qué hacemos',
      ctaSecondary: 'Quiénes somos',
      meaning: 'Tair',
      meaningDef: 'verbo · hebreo',
      meaningPhonetic: '/ta·ír/',
      meaningTranslation: '"va a traer luz"',
      meaningCopy: 'El nombre Tair fue escogido para reflejar el propósito de la sociedad: traer claridad, oportunidad y luz a cada proyecto en el que participamos.',
      verticalsTitle: 'Cuatro frentes. Un mismo principio.',
      verticalsSubtitle: 'Concentramos la inversión y la gestión en cuatro áreas donde aportamos valor desde la primera idea hasta la entrega final.',
      stat1Label: 'Año de fundación',
      stat1Value: '2012',
      stat2Label: 'Verticales de negocio',
      stat2Value: '04',
      stat3Label: 'Productos de software',
      stat3Value: '05',
    },
    verticals: {
      v1: {
        title: 'Gestión Inmobiliaria',
        short: 'De la idea a la entrega de los departamentos.',
        long: 'Conducimos todo el ciclo inmobiliario: ideación, factibilidad, aprobación, diseño, construcción y entrega final a compradores.',
      },
      v2: {
        title: 'Inversión Inmobiliaria',
        short: 'Accionistas en proyectos Delabase en desarrollo.',
        long: 'Participamos como accionistas en cada proyecto en desarrollo de Delabase Inmobiliaria, una marca respaldada por más de 50 años de experiencia.',
      },
      v3: {
        title: 'Bodegaje Industrial',
        short: 'Centro logístico y productivo Chañarcillo.',
        long: 'Inversión en complejo industrial con ubicación estratégica, accesos controlados, seguridad 24/7 y alta capacidad eléctrica.',
      },
      v4: {
        title: 'Desarrollo de Software',
        short: 'Ideas convertidas en software con foco de mercado.',
        long: 'Creamos productos digitales que abordan oportunidades de mercado: gestión, productividad, juegos y herramientas para industrias específicas.',
      },
    },
    about: {
      eyebrow: 'Quiénes somos',
      title: 'Una sociedad pensada para iluminar buenas inversiones.',
      subtitle: 'Inversiones Tair SpA nace en 2012 como vehículo de inversión y gestión de un grupo familiar con larga trayectoria en el rubro inmobiliario, industrial y tecnológico.',
      foundedTitle: 'Fundada en',
      foundedYear: '2012',
      foundedBody: 'Más de una década respaldando proyectos en industrias que requieren visión de largo plazo, disciplina y excelencia operativa.',
      ownershipTitle: 'Estructura societaria',
      ownershipBody: 'La sociedad es controlada por:',
      owner1: 'Inversiones 29 de Sivan Ltda',
      owner2: 'Inversiones La Loma Ltda',
      leadershipTitle: 'Representante Legal',
      leadershipName: 'Alan Guendelman',
      leadershipRole: 'Representante Legal · Inversiones Tair SpA',
      meaningTitle: 'El significado de Tair',
      meaningBody: 'En hebreo, Tair significa "va a traer luz". Es la promesa que guía cada decisión de inversión: aportar claridad, oportunidad y dirección.',
      principlesTitle: 'Lo que nos define',
      p1Title: 'Visión de largo plazo',
      p1Body: 'Invertimos donde podemos sostener proyectos por décadas, no por trimestres.',
      p2Title: 'Disciplina financiera',
      p2Body: 'Cada inversión se mide en su propio mérito y en su contribución al conjunto.',
      p3Title: 'Excelencia en la ejecución',
      p3Body: 'De la mano de socios operadores con trayectoria comprobada en cada vertical.',
    },
    whatWeDo: {
      eyebrow: 'Qué hacemos',
      title: 'Cuatro verticales. Un mismo estándar.',
      subtitle: 'Concentramos capital y gestión en industrias donde podemos aportar valor real, sostenido y verificable.',
      exploreCta: 'Explorar vertical',
    },
    v1Page: {
      eyebrow: 'Vertical 01 · Gestión Inmobiliaria',
      title: 'Acompañamos un proyecto desde la idea hasta las llaves.',
      intro: 'Gestionamos el ciclo completo del proceso inmobiliario: creación de la idea, factibilidad, aprobación del proyecto, diseño, construcción y la entrega final de cada departamento al comprador.',
      processTitle: 'El proceso, de extremo a extremo',
      step1: 'Idea y factibilidad',
      step1Body: 'Búsqueda y evaluación de terrenos, estudio de mercado y modelado financiero del proyecto.',
      step2: 'Aprobación y permisos',
      step2Body: 'Gestión integral de permisos municipales, anteproyectos y trámites regulatorios.',
      step3: 'Diseño',
      step3Body: 'Diseño arquitectónico junto a A3ARQ, optimizando habitabilidad, costos y experiencia.',
      step4: 'Construcción',
      step4Body: 'Ejecución con Constructora Daniel Salinas, con más de 50 años de experiencia en el rubro.',
      step5: 'Comercialización y entrega',
      step5Body: 'Venta, postventa y entrega de departamentos a sus nuevos propietarios.',
      partnersTitle: 'Socios operadores',
      partner1Name: 'Toltén Gestión Inmobiliaria',
      partner1Desc: 'Gestión integral de proyectos inmobiliarios.',
      partner2Name: 'A3ARQ',
      partner2Desc: 'Oficina de arquitectura responsable del diseño de los proyectos.',
      partner3Name: 'Constructora Daniel Salinas',
      partner3Desc: 'Constructora con más de 50 años ejecutando obras residenciales y comerciales.',
    },
    v2Page: {
      eyebrow: 'Vertical 02 · Inversión Inmobiliaria',
      title: 'Accionistas en cada Delabase en desarrollo.',
      intro: 'Inversiones Tair SpA participa como accionista en cada uno de los proyectos en desarrollo de Delabase Inmobiliaria, sumándose al conjunto de inversionistas que apoyan su crecimiento.',
      whyTitle: 'Por qué Delabase',
      why1Title: 'Larga trayectoria',
      why1Body: 'Construidos por Constructora Salinas, con más de 50 años en el rubro.',
      why2Title: 'Alta plusvalía',
      why2Body: 'Proyectos en barrios emergentes con buena conectividad e ideal perfil de inversión.',
      why3Title: 'Asesoría constante',
      why3Body: 'Equipo experto que acompaña en todo el proceso de compra y postventa.',
      projectsTitle: 'Proyectos en cartera',
      p1: 'Edificio Volcán',
      p1Loc: 'Villarrica',
      p2: 'Edificio Augusto Biaut',
      p2Loc: 'La Cisterna',
      p3: 'Edificio Carvajal 0330',
      p3Loc: 'La Cisterna',
      p4: 'Edificio Don Claudio',
      p4Loc: 'La Cisterna',
    },
    v3Page: {
      eyebrow: 'Vertical 03 · Bodegaje Industrial',
      title: 'Complejo logístico y productivo Chañarcillo.',
      intro: 'Inversión en un centro de bodegaje industrial operado por ABSA Chile, diseñado para empresas que requieren ubicación estratégica, seguridad y alta disponibilidad eléctrica.',
      features: 'Por qué Chañarcillo',
      f1Title: 'Ubicación estratégica',
      f1Body: 'Acceso a Américo Vespucio, Camino a Melipilla, General Velásquez y Camino a Lonquén. Cerca del futuro data center de Google.',
      f2Title: 'Seguridad 24/7',
      f2Body: 'Accesos controlados, televigilancia perimetral, iluminación y guardias permanentes.',
      f3Title: 'Alta capacidad eléctrica',
      f3Body: '2.500 KWh conectados con dos subestaciones eléctricas a solo 700 metros de distancia.',
      f4Title: 'Infraestructura flexible',
      f4Body: 'Oficinas desde 8 m² hasta bodegas de 12.500 m², con accesos controlados y zonas de carga.',
    },
    v4Page: {
      eyebrow: 'Vertical 04 · Desarrollo de Software',
      title: 'Ideas convertidas en software con foco de mercado.',
      intro: 'Diseñamos, desarrollamos y operamos productos digitales propios, enfocados en oportunidades de mercado en industrias específicas.',
      productsTitle: 'Nuestros productos',
      cisTitle: 'CIS',
      cisDesc: 'Aplicación de navegación de cementerios que permite ubicar sepulturas, recorrer cuarteles y rendir homenaje a los seres queridos.',
      cachoTitle: 'Cachodice',
      cachoDesc: 'App para jugar Cacho, el clásico juego de dados chileno, con tablero digital y partidas multijugador.',
      imTitle: 'InmobiliariaManager',
      imDesc: 'Software de gestión integral para inmobiliarias: proyectos, unidades, cotizaciones, reservas y postventa.',
      leitTitle: 'Leitpalel',
      leitDesc: 'Aplicación para aprender a rezar en hebreo, con transliteración, audio y acompañamiento paso a paso.',
      recetarioTitle: 'Recetario App',
      recetarioDesc: 'Libro de recetas familiar virtual con recetas tradicionales y los momentos históricos de la familia ligados a la cocina.',
    },
    contact: {
      eyebrow: 'Contacto',
      title: 'Hablemos.',
      subtitle: 'Para consultas societarias, comerciales o de inversión, escríbenos directamente. Te responderemos a la brevedad.',
      addressTitle: 'Dirección',
      addressLine: 'Román Díaz 300, Of. 101',
      addressCity: 'Providencia, Santiago, Chile',
      emailTitle: 'Correo electrónico',
      phoneTitle: 'Teléfono',
      legalTitle: 'Representante legal',
      legalName: 'Alan Guendelman',
    },
    footer: {
      tagline: 'Va a traer luz.',
      navTitle: 'Navegación',
      verticalsTitle: 'Verticales',
      contactTitle: 'Contacto',
      rights: 'Todos los derechos reservados.',
      legal: 'Representante Legal: Alan Guendelman',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      whatWeDo: 'What We Do',
      contact: 'Contact',
    },
    common: {
      learnMore: 'Learn more',
      back: 'Back',
      readMore: 'Read more',
      visitSite: 'Visit site',
      ourPartners: 'Our partners',
      keyFeatures: 'Key features',
      products: 'Products',
    },
    home: {
      eyebrow: 'Investment holding · Chile · since 2012',
      heroTitle1: 'Bringing',
      heroTitle2: 'light.',
      heroSubtitle: 'Inversiones Tair SpA is a Chilean holding company that lights the path from vision to investment: real estate development, industrial warehousing and purposeful software.',
      ctaPrimary: 'What we do',
      ctaSecondary: 'About us',
      meaning: 'Tair',
      meaningDef: 'verb · Hebrew',
      meaningPhonetic: '/ta·eer/',
      meaningTranslation: '"will bring light"',
      meaningCopy: 'The name Tair was chosen to reflect the purpose of the company: bringing clarity, opportunity and light to every project we are part of.',
      verticalsTitle: 'Four fronts. One principle.',
      verticalsSubtitle: 'We focus capital and management on four areas where we add real value, from the first idea to final delivery.',
      stat1Label: 'Founded',
      stat1Value: '2012',
      stat2Label: 'Business verticals',
      stat2Value: '04',
      stat3Label: 'Software products',
      stat3Value: '05',
    },
    verticals: {
      v1: {
        title: 'Real Estate Management',
        short: 'From idea to apartment delivery.',
        long: 'We lead the entire real estate cycle: ideation, feasibility, approval, design, construction and final delivery to buyers.',
      },
      v2: {
        title: 'Real Estate Investment',
        short: 'Shareholders in every Delabase project under development.',
        long: 'We participate as shareholders in every project under development by Delabase Inmobiliaria, a brand backed by 50+ years of experience.',
      },
      v3: {
        title: 'Industrial Warehousing',
        short: 'Chañarcillo logistics and production hub.',
        long: 'Investment in an industrial complex with strategic location, controlled access, 24/7 security and high electrical capacity.',
      },
      v4: {
        title: 'Software Development',
        short: 'Ideas turned into market-driven software.',
        long: 'We build digital products that tackle real market opportunities: management, productivity, games and tools for specific industries.',
      },
    },
    about: {
      eyebrow: 'About us',
      title: 'A company designed to light up sound investments.',
      subtitle: 'Inversiones Tair SpA was founded in 2012 as the investment and management vehicle of a family group with long-standing experience in real estate, industrial and technology businesses.',
      foundedTitle: 'Founded in',
      foundedYear: '2012',
      foundedBody: 'Over a decade backing projects in industries that demand long-term vision, discipline and operational excellence.',
      ownershipTitle: 'Ownership structure',
      ownershipBody: 'The company is controlled by:',
      owner1: 'Inversiones 29 de Sivan Ltda',
      owner2: 'Inversiones La Loma Ltda',
      leadershipTitle: 'Legal Representative',
      leadershipName: 'Alan Guendelman',
      leadershipRole: 'Legal Representative · Inversiones Tair SpA',
      meaningTitle: 'The meaning of Tair',
      meaningBody: 'In Hebrew, Tair means "will bring light". It is the promise that guides every investment decision: providing clarity, opportunity and direction.',
      principlesTitle: 'What defines us',
      p1Title: 'Long-term vision',
      p1Body: 'We invest where we can sustain projects for decades, not quarters.',
      p2Title: 'Financial discipline',
      p2Body: 'Every investment is judged on its own merit and on its contribution to the whole.',
      p3Title: 'Excellence in execution',
      p3Body: 'Hand in hand with operating partners with proven track record in each vertical.',
    },
    whatWeDo: {
      eyebrow: 'What we do',
      title: 'Four verticals. One standard.',
      subtitle: 'We focus capital and management on industries where we can deliver real, sustained and verifiable value.',
      exploreCta: 'Explore vertical',
    },
    v1Page: {
      eyebrow: 'Vertical 01 · Real Estate Management',
      title: 'We walk every project from concept to keys.',
      intro: 'We manage the full real estate cycle: idea creation, feasibility, project approval, design, construction and the final delivery of each apartment to its buyer.',
      processTitle: 'The process, end to end',
      step1: 'Idea & feasibility',
      step1Body: 'Land sourcing and evaluation, market research and financial modelling.',
      step2: 'Approval & permits',
      step2Body: 'Full management of municipal permits, pre-projects and regulatory approvals.',
      step3: 'Design',
      step3Body: 'Architectural design with A3ARQ, optimising livability, cost and experience.',
      step4: 'Construction',
      step4Body: 'Built by Constructora Daniel Salinas, with 50+ years of experience in the industry.',
      step5: 'Sales & delivery',
      step5Body: 'Sales, after-sales service and final delivery of apartments to their new owners.',
      partnersTitle: 'Operating partners',
      partner1Name: 'Toltén Gestión Inmobiliaria',
      partner1Desc: 'End-to-end real estate project management.',
      partner2Name: 'A3ARQ',
      partner2Desc: 'Architecture studio responsible for project design.',
      partner3Name: 'Constructora Daniel Salinas',
      partner3Desc: 'Construction company with 50+ years building residential and commercial works.',
    },
    v2Page: {
      eyebrow: 'Vertical 02 · Real Estate Investment',
      title: 'Shareholders in every Delabase under development.',
      intro: 'Inversiones Tair SpA participates as a shareholder in every project under development by Delabase Inmobiliaria, joining the broader investor group supporting its growth.',
      whyTitle: 'Why Delabase',
      why1Title: 'Long track record',
      why1Body: 'Built by Constructora Salinas, with 50+ years in the industry.',
      why2Title: 'Strong upside',
      why2Body: 'Projects in emerging neighborhoods with great connectivity and investment fundamentals.',
      why3Title: 'Constant advisory',
      why3Body: 'Expert team accompanying the entire purchase and after-sales process.',
      projectsTitle: 'Portfolio projects',
      p1: 'Edificio Volcán',
      p1Loc: 'Villarrica',
      p2: 'Edificio Augusto Biaut',
      p2Loc: 'La Cisterna',
      p3: 'Edificio Carvajal 0330',
      p3Loc: 'La Cisterna',
      p4: 'Edificio Don Claudio',
      p4Loc: 'La Cisterna',
    },
    v3Page: {
      eyebrow: 'Vertical 03 · Industrial Warehousing',
      title: 'Chañarcillo logistics and production hub.',
      intro: 'Investment in an industrial warehousing center operated by ABSA Chile, designed for companies that require strategic location, security and high electrical availability.',
      features: 'Why Chañarcillo',
      f1Title: 'Strategic location',
      f1Body: 'Access to Américo Vespucio, Camino a Melipilla, General Velásquez and Camino a Lonquén. Close to the upcoming Google data center.',
      f2Title: '24/7 security',
      f2Body: 'Controlled access, perimeter video surveillance, lighting and permanent on-site guards.',
      f3Title: 'High electrical capacity',
      f3Body: '2,500 KWh connected with two electrical substations just 700 meters away.',
      f4Title: 'Flexible infrastructure',
      f4Body: 'Offices from 8 m² up to warehouses of 12,500 m², with controlled access and loading zones.',
    },
    v4Page: {
      eyebrow: 'Vertical 04 · Software Development',
      title: 'Ideas turned into market-driven software.',
      intro: 'We design, develop and operate proprietary digital products focused on market opportunities in specific industries.',
      productsTitle: 'Our products',
      cisTitle: 'CIS',
      cisDesc: 'Cemetery navigation app that helps families locate graves, walk through sections and pay tribute to their loved ones.',
      cachoTitle: 'Cachodice',
      cachoDesc: 'App to play Cacho, the classic Chilean dice game, with a digital board and multiplayer matches.',
      imTitle: 'InmobiliariaManager',
      imDesc: 'End-to-end management software for real estate companies: projects, units, quotes, reservations and after-sales.',
      leitTitle: 'Leitpalel',
      leitDesc: 'App to learn how to pray in Hebrew, with transliteration, audio and step-by-step guidance.',
      recetarioTitle: 'Recetario App',
      recetarioDesc: 'Virtual family recipe book with traditional recipes and the family historical moments tied to cooking.',
    },
    contact: {
      eyebrow: 'Contact',
      title: 'Let\u2019s talk.',
      subtitle: 'For corporate, commercial or investment inquiries, write to us directly. We will get back to you shortly.',
      addressTitle: 'Address',
      addressLine: 'Román Díaz 300, Of. 101',
      addressCity: 'Providencia, Santiago, Chile',
      emailTitle: 'Email',
      phoneTitle: 'Phone',
      legalTitle: 'Legal representative',
      legalName: 'Alan Guendelman',
    },
    footer: {
      tagline: 'Bringing light.',
      navTitle: 'Navigation',
      verticalsTitle: 'Verticals',
      contactTitle: 'Contact',
      rights: 'All rights reserved.',
      legal: 'Legal Representative: Alan Guendelman',
    },
  },
};
